import { render } from "./WCEditSpecialOrderItemButton.vue?vue&type=template&id=4cbfc93f"
import script from "./WCEditSpecialOrderItemButton.vue?vue&type=script&lang=js"
export * from "./WCEditSpecialOrderItemButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__